import styled from 'styled-components';

// CONSTANTS
import { WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.section`
  background-color: ${WHITE};
  padding-top: 60px;
  padding-bottom: 60px;

  .free-tv-section {
    &__img {
      text-align: left;

      img {
        max-width: 100%;
      }
    }
  }

  ${breakpoints.down('xs')} {
    padding-top: 40px;
  }
`;

export default Container;
